import React from 'react';
import { getPropertiesFromFeature } from '../../../../../utils/driverUtils';
import { Card } from 'react-bootstrap';

import UndevelopedFeature from './ledmoduleProperties/UndevelopedFeature';
import BasicNominalData from './ledmoduleProperties/BasicNominalData';
import AdvancedNominalData from './ledmoduleProperties/AdvancedNominalData';
import NominalData from './ledmoduleProperties/NominalData';
import ModuleArchitecture from './ledmoduleProperties/ModuleArchitecture';
import ThermalCharacteristics from './ledmoduleProperties/ThermalCharacteristics';
import CurrentDependencies from './ledmoduleProperties/CurrentDependencies';
import TemperatureDependencies from './ledmoduleProperties/TemperatureDependencies';

import {
    BASIC_NOMINAL_DATA,
    ADVANCED_NOMINAL_DATA,
    NOMINAL_DATA,
    MODULE_ARCHITECTURE,
    THERMAL_CHARACTERISTICS,
    CURRENT_DEPENDENCIES,
    TEMPERATURE_DEPENDENCIES,
} from '../../../../../utils/constantFeatures';

export default class LedmoduleFeature extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            properties: null,
        }

        this.handleChange = this.handleChange.bind(this);
    }

    static getDerivedStateFromProps(props, state) {

        if (props.feature && props.properties) {
            return {
                properties: getPropertiesFromFeature(props.feature, props.properties, props.ledmodule.type)
            };
        }

        return null;
    }

    handleChange(propertyName, value) {

        this.setState(function (state) {
            state.properties[propertyName].value = value;
            return state;
        });

        this.props.handleChangeDriverProperties(propertyName, value);
    }

    render() {

        if (!this.props.feature || !this.props.properties || !this.state || !this.state.properties) {
            return null;
        }

        const properties = this.state.properties;

        let featureComponent = null;
        let warningComponent = null;
        switch (this.props.feature.name) {
            case BASIC_NOMINAL_DATA.shortName: {
                featureComponent = <BasicNominalData
                    driver={this.props.driver}
                    feature={this.props.feature}
                    properties={properties}
                    handleChange={this.handleChange} />
                break;
            }
            case ADVANCED_NOMINAL_DATA.shortName: {
                featureComponent = <AdvancedNominalData
                    driver={this.props.driver}
                    feature={this.props.feature}
                    properties={properties}
                    handleChange={this.handleChange} />
                break;
            }
            case NOMINAL_DATA.shortName: {
                featureComponent = <NominalData
                    driver={this.props.driver}
                    feature={this.props.feature}
                    properties={properties}
                    handleChange={this.handleChange} />
                break;
            }
            case MODULE_ARCHITECTURE.shortName: {
                featureComponent = <ModuleArchitecture
                    driver={this.props.driver}
                    feature={this.props.feature}
                    properties={properties}
                    handleChange={this.handleChange} />
                break;
            }
            case THERMAL_CHARACTERISTICS.shortName: {
                featureComponent = <ThermalCharacteristics
                    driver={this.props.driver}
                    feature={this.props.feature}
                    properties={properties}
                    handleChange={this.handleChange} />
                break;
            }
            case CURRENT_DEPENDENCIES.shortName: {
                featureComponent = <CurrentDependencies
                    driver={this.props.driver}
                    feature={this.props.feature}
                    properties={properties}
                    handleChange={this.handleChange} />
                break;
            }
            case TEMPERATURE_DEPENDENCIES.shortName: {
                featureComponent = <TemperatureDependencies
                    driver={this.props.driver}
                    feature={this.props.feature}
                    properties={properties}
                    handleChange={this.handleChange} />
                break;
            }
            default: {
                featureComponent = <UndevelopedFeature
                    driver={this.props.driver}
                    feature={this.props.feature}
                    properties={properties}
                    handleChange={this.handleChange} />
                break;
            }
        }

        return (
            <div>
                <Card className="card-body-feature-component">
                    <Card.Body className="card-body-ledmodule-feature-component">
                        {featureComponent}
                        {warningComponent}
                    </Card.Body>
                </Card>
            </div>
        );
    }
}
